import { render } from "./SiteDetails.vue?vue&type=template&id=b1573d26&ts=true"
import script from "./SiteDetails.vue?vue&type=script&lang=ts"
export * from "./SiteDetails.vue?vue&type=script&lang=ts"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__